import React from 'react';
import PricingPackages from './PricingPackages';

export default function PricingPage() {
  return (
    <>
      <section className="py-12 bg-[var(--color-background)]">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-[var(--color-primary)] mb-10 text-center">Fiyatlandırma</h1>
          <PricingPackages />
        </div>
      </section>
    </>
  );
} 